if (
	globalThis.externalPublicPath &&
	globalThis.externalPublicPath.endsWith('/')
) {
	globalThis.viteExternalPublicPath = globalThis.externalPublicPath.slice(
		0,
		-1,
	);
}
